import { handleActions } from "redux-actions";

import {
    PAGE_LEAVE,
    SUMMARY_DATA_REQUEST,
    SUMMARY_DATA_SUCCESS,
    SUMMARY_DATA_FAILURE,
    SUMMARY_EXPORT_REQUEST,
    SUMMARY_EXPORT_SUCCESS,
    SUMMARY_EXPORT_FAILURE,
} from "constants/action-types";

type Totals = { quantity: number; items: number; value: number };
type Delivery = { groups: { [key: string]: Totals } } & Totals;

export type FullReportData = {
    currency: string;
    deliveries: { [key: string]: Delivery };
    deliverySort: string[];
    orderTotal?: number;
} & Totals;

export type SummaryState = {
    summaryData?: FullReportData;
    isFetching: boolean;
    isExporting: boolean;
    fetchError?: {};
    exportError?: {};
    onSnackbarAdd?: () => any;
    error?: any;
};

const initialState: SummaryState = { isFetching: true, isExporting: false };

const summaryReducer = handleActions(
    {
        [PAGE_LEAVE]: () => initialState,
        [SUMMARY_DATA_REQUEST]: (state: SummaryState): SummaryState => ({
            ...state,
            isFetching: true,
            error: undefined,
        }),
        [SUMMARY_DATA_SUCCESS]: (state: SummaryState, { data: summaryData }: any): SummaryState => ({
            ...state,
            isFetching: false,
            summaryData,
        }),
        [SUMMARY_DATA_FAILURE]: (state: SummaryState, error): SummaryState => ({
            ...state,
            isFetching: false,
            error,
        }),
        [SUMMARY_EXPORT_REQUEST]: (state: SummaryState) => ({
            ...state,
            isExporting: true,
            exportError: undefined,
        }),
        [SUMMARY_EXPORT_SUCCESS]: (state: SummaryState) => ({
            ...state,
            isExporting: false,
        }),
        [SUMMARY_EXPORT_FAILURE]: (state: SummaryState, error) => ({
            ...state,
            isExporting: false,
            exportError: error,
        }),
    },
    initialState,
);

export default summaryReducer;
